import { call, put, takeLatest } from "redux-saga/effects";
import {
  onVendorPost,
  onVendorPostSuccess,
  onVendorPostError,
  onGetVendors,
  onGetVendorsSuccess,
  onGetVendorsError,
} from "../Store/Slices/vendorSlice";
import {
  callVendorPostApi,
  callGetVendorsApi,
} from "../Context/businessApi";

function* vendorPostSaga({ payload }) {
  try {
    const response = yield call(callVendorPostApi, payload);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200 || code === 201 || code === "201") {
      yield put(
        onVendorPostSuccess({
          message: response.message || "Vendor added successfully",
          status_code: code,
        })
      );
    } else {
      yield put(
        onVendorPostError({
          message: response.message || "Vendor post failed",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onVendorPostError({ message, status_code: 400 }));
  }
}

function* getVendorsSaga({ payload }) {
  try {
    const response = yield call(callGetVendorsApi, payload ?? {});
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      const data = response.data?.vendors ?? response.data ?? null;
      yield put(
        onGetVendorsSuccess({
          data,
          message: response.message || "Vendors retrieved",
          status_code: code,
        })
      );
    } else {
      yield put(
        onGetVendorsError({
          data: response.data ?? null,
          message: response.message || "Failed to fetch vendors",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onGetVendorsError({ data: null, message, status_code: 400 }));
  }
}

export default function* vendorSaga() {
  yield takeLatest(onVendorPost.type, vendorPostSaga);
  yield takeLatest(onGetVendors.type, getVendorsSaga);
}
